import { render, staticRenderFns } from "./CursorTrigger.vue?vue&type=template&id=0c12c619&"
import script from "./CursorTrigger.vue?vue&type=script&lang=js&"
export * from "./CursorTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports